import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';
import { firebaseConfig } from '@config/index';

// Initialiser Firebase
export const app = initializeApp(firebaseConfig);

// Services Firebase
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west3');

// Analytics (Safe check for SSR/Support + API not enabled)
let analytics = null;
try {
    analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
} catch (e) {
    console.warn('[Firebase] Analytics non disponible:', e);
}
export { analytics };

// Export par défaut
export default app;
